export default {
    data() {
        return {
            checkValue: false,
        }
    },
    watch: {
        checkValue: function(val) {
            console.log('checkValue', val)
        },
    },
    methods: {
        doToast(title, message, variant) {
            this.$bvToast.toast(message, {
                title,
                variant,
                solid: true,
                toaster: 'b-toaster-top-center',
            })
        },
        async confirmMessage(title, message) {
            const value = await this.$bvModal.msgBoxConfirm(message, {
                title,
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true,
            })
            return value
        },

        async optionsMessage(title, content) {
            // const self = this
            let optionSelected = false
            const h = this.$createElement
            const titleVNode = h('div', { domProps: { innerHTML: title } })
            const messageVNode = h('div', [
                h(
                    'b-form-checkbox',
                    {
                        on: {
                            input: function(event) {
                                console.log('checkValue--event', event)
                                optionSelected = event
                            },
                        },
                    },
                    [h('span', { domProps: { innerHTML: content } })]
                ),
            ])

            const confirmed = await this.$bvModal.msgBoxConfirm(
                [messageVNode],
                {
                    title: [titleVNode],
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Submit',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                }
            )

            console.log('optionSelected', optionSelected)
            return { confirmed, optionSelected }
        },
    },
}
